import { css } from '@styled-system/css';
import type { FC } from 'react';

interface NewStatusIndicatorProps {
  className?: string;
}

export const NewStatusIndicator: FC<NewStatusIndicatorProps> = ({ className }) => {
  const containerStyles = css({
    w: '0.4375rem', // 7px
    h: '0.4375rem', // 7px
  });

  return (
    <div className={containerStyles + (className ? ` ${className}` : '')}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 21 21"
        fill="none"
        className={css({
          transform: 'scale(3)',
        })}
      >
        <g filter="url(#filter0_f_11_230)">
          <circle cx="10.5" cy="10.5" r="3.5" fill="#FFA852" />
        </g>
        <circle cx="10" cy="10" r="3" fill="#FFA852" />
        <defs>
          <filter
            id="filter0_f_11_230"
            x="0.3"
            y="0.3"
            width="20.4"
            height="20.4"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="3.35" result="effect1_foregroundBlur_11_230" />
          </filter>
        </defs>
      </svg>
    </div>
  );
};
